var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-navigation-drawer',{attrs:{"absolute":"","permanent":"","right":"","width":450}},[_c('v-btn',{staticClass:"ma-2",attrs:{"icon":""},on:{"click":_setup.store.commit.toggleShowProvenanceVis}},[_c('v-icon',[_vm._v("mdi-close")])],1),_c('div',{ref:"provDiv",attrs:{"id":"provDiv"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }